import { connect } from 'react-redux';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import PartnerIntegrationPage from './page';
import IntegrationRequestService from './service';
import { fetchIntegrationRequests } from './actions';
import {
    getVisibleIntegrationRequests,
    getIntegrationRequestsError,
    getIntegrationRequestsLoaded,
    getIntegrationRequestsLoading,
} from '../selectors/partnerIntegration';

const service = new IntegrationRequestService();

const PartnerIntegrationContainer = ({ requests, loading, loaded, error = null, onRefreshRequests }) => {
    useEffect(() => {
        if (!loaded && !loading) {
            onRefreshRequests();
        }
    }, [loaded, loading, onRefreshRequests]);

    return (
        <PartnerIntegrationPage requests={requests} loading={loading} loaded={loaded} error={error} />
    );
};

PartnerIntegrationContainer.propTypes = {
    requests: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onRefreshRequests: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    requests: getVisibleIntegrationRequests(state),
    loading: getIntegrationRequestsLoading(state),
    loaded: getIntegrationRequestsLoaded(state),
    error: getIntegrationRequestsError(state),
});

const mapDispatchToProps = dispatch => ({
    onRefreshRequests: () => fetchIntegrationRequests({ dispatch, service }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PartnerIntegrationContainer);
